var render, staticRenderFns
import script from "./z-table.vue?vue&type=script&lang=js&"
export * from "./z-table.vue?vue&type=script&lang=js&"
import style0 from "./z-table.vue?vue&type=style&index=0&id=8b6b4376&lang=scss&scoped=true&"
import style1 from "./z-table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b4376",
  null
  
)

export default component.exports